module.exports = __webpack_public_path__ + "media/src/assets/Images/AppStoreButtonImage-5828a3ec2546263e5048e8428d91869b.svg";